<script>
	import { onMount } from 'svelte'
	import { ghRoomNumber, fetch_rooms_from_db } from '../AdminModule.svelte'
	import { get_room_number } from '../../../library/scripts/utils'
	import TwoCols from '../../../library/columLayouts/TwoCols.svelte'
	import RoomsPreview from './RoomsPreview.svelte'
	import RoomsEntry from './RoomsEntry.svelte'

	//holds the menu objects
	let rooms = []

	//set the latest room number to store
	const roomNumber = get_room_number()

	roomNumber.then((value) => {
		ghRoomNumber.set(value)
	})

	//load the menu from db

	onMount(() => {
		fetch_rooms_from_db()
	})
</script>

<TwoCols column="290px" alignVertical="start">
	<div slot="column1">
		<RoomsEntry />
	</div>

	<div slot="column2">
		<RoomsPreview />
	</div>
</TwoCols>
